import { useState } from 'react';
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileAudio,
  FaFileVideo,
  FaFileArchive,
  FaFileAlt,
  FaFileCode,
  FaFilePowerpoint,
  FaFileCsv,
} from 'react-icons/fa';

// Helper: returns an icon based on file extension
const getFileIcon = (filename, size = 15) => {
  const ext = (filename || '').split('.').pop().toLowerCase();
  if (['pdf'].includes(ext))
    return <FaFilePdf size={size} className="text-red-500" />;
  if (['doc', 'docx'].includes(ext))
    return <FaFileWord size={size} className="text-[#5652CF]" />;
  if (['xls', 'xlsx'].includes(ext))
    return <FaFileExcel size={size} className="text-green-500" />;
  if (['ppt', 'pptx'].includes(ext))
    return <FaFilePowerpoint size={size} className="text-orange-500" />;
  if (['csv'].includes(ext))
    return <FaFileCsv size={size} className="text-teal-500" />;
  if (['txt', 'md', 'markdown'].includes(ext))
    return <FaFileAlt size={size} className="text-gray-500" />;
  if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'ico'].includes(ext))
    return <FaFileImage size={size} className="text-yellow-500" />;
  if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext))
    return <FaFileArchive size={size} className="text-gray-500" />;
  if (['mp3', 'wav', 'ogg', 'flac'].includes(ext))
    return <FaFileAudio size={size} className="text-purple-500" />;
  if (['mp4', 'avi', 'mkv', 'mov', 'wmv'].includes(ext))
    return <FaFileVideo size={size} className="text-indigo-500" />;
  if (
    ['js', 'jsx', 'ts', 'tsx', 'html', 'css', 'json', 'xml', 'py'].includes(ext)
  )
    return <FaFileCode size={size} className="text-green-700" />;
  // default
  return <FaFileAlt size={size} className="text-gray-500" />;
};

const AttachmentItem = ({ file }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="inline-flex h-10 w-40 cursor-pointer items-center justify-center rounded-lg border p-2 py-3 text-gray-500 shadow-md"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered ? (
        <div className="flex w-full items-center justify-center gap-4">
          <button className="ml-2 text-gray-600 hover:text-red-400">
            &times;
          </button>
        </div>
      ) : (
        <div className="flex w-full items-center space-x-2">
          <div className="flex h-8 w-8 items-center justify-center">
            {getFileIcon(file.name.split('.').pop().toLowerCase())}{' '}
            {/* Handle both cases */}
          </div>
          <span className="truncate text-sm font-medium">
            {file.name} {/* Handle both cases */}
          </span>
        </div>
      )}
    </div>
  );
};

export { getFileIcon };
export default AttachmentItem;
